export default "__VITE_ASSET__64741fe7__"